module.exports = __webpack_public_path__ + "static/img/member10.774f95e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member10.png
// module id = 7220
// module chunks = 0